import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export default function useScrollToTop() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const hasHash = window.location.hash.length > 0;

    if (!hasHash) {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, searchParams]);
}
